import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const FREE_FEATURES = [
  'Call Recorder + Call Processor for Windows',
  'Local transcription with Whisper (small.en)',
  'AI follow-up packet for every call',
  'Google Sheet sync + calendar holds',
  'Automatic app updates',
  'Unlimited calls during launch',
];

const PRO_FEATURES = [
  'Everything in Free',
  'Team pipelines and shared sheets',
  'Higher-accuracy transcription models',
  'CRM integrations',
  'Priority support',
];

export default function Pricing() {
  return (
    <div className="container-page py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="font-display text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
          Simple pricing while we launch
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          Free for everyone during launch. Paid plans arrive later and will not change what your
          free account already does.
        </p>
      </div>

      <div className="mx-auto mt-14 grid max-w-4xl gap-6 md:grid-cols-2">
        {/* Free */}
        <div className="relative flex flex-col rounded-2xl border-2 border-primary bg-card p-8 shadow-lift">
          <span className="absolute -top-3 left-8 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground">
            Available now
          </span>
          <h2 className="font-display text-xl font-semibold text-foreground">Free</h2>
          <p className="mt-1 text-sm text-muted-foreground">The full product during launch.</p>
          <div className="mt-6 flex items-end gap-1.5">
            <span className="font-display text-5xl font-bold text-foreground">$0</span>
            <span className="pb-1.5 text-sm text-muted-foreground">/ month</span>
          </div>
          <ul className="mt-7 space-y-3">
            {FREE_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-foreground">
                <Check size={18} className="mt-0.5 shrink-0 text-accent" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 pt-2">
            <Link to="/signup">
              <Button className="w-full" size="lg">
                Create free account
              </Button>
            </Link>
          </div>
        </div>

        {/* Pro — coming soon */}
        <div className="relative flex flex-col rounded-2xl border border-border bg-card/60 p-8">
          <span className="absolute -top-3 left-8 inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-3 py-1 text-xs font-semibold text-muted-foreground">
            <Sparkles size={13} /> Coming soon
          </span>
          <h2 className="font-display text-xl font-semibold text-foreground">Pro</h2>
          <p className="mt-1 text-sm text-muted-foreground">For teams and power users. Later.</p>
          <div className="mt-6 flex items-end gap-1.5">
            <span className="font-display text-5xl font-bold text-muted-foreground">—</span>
          </div>
          <ul className="mt-7 space-y-3">
            {PRO_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2.5 text-sm text-muted-foreground">
                <Check size={18} className="mt-0.5 shrink-0 text-muted-foreground/60" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 pt-2">
            <Button className="w-full" size="lg" variant="outline" disabled>
              Not yet available
            </Button>
          </div>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-xl text-center text-sm text-muted-foreground">
        No checkout, no credit card, no trial clock. When Pro is ready we will announce it here.
      </p>
    </div>
  );
}
